import api from './api';

/**
 * Matching Service
 * Handles AI-powered professional matching
 */
export const matchingService = {
  // ==================== Match Recommendations ====================
  
  /**
   * Get match recommendations
   */
  async getMatchRecommendations(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/matching/recommendations?${queryString}`);
  },

  /**
   * Get comprehensive matches
   */
  async getComprehensiveMatches(criteria) {
    return api.post('/matching/comprehensive', criteria);
  },

  // ==================== Match Preferences ====================
  
  /**
   * Get match preferences
   */
  async getMatchPreferences() {
    return api.get('/matching/preferences');
  },

  /**
   * Update match preferences
   */
  async updateMatchPreferences(preferences) {
    return api.put('/matching/preferences', preferences);
  },

  // ==================== Match Feedback ====================
  
  /**
   * Provide match feedback
   */
  async provideFeedback(matchId, feedback) {
    return api.post(`/matching/${matchId}/feedback`, feedback);
  },

  /**
   * Accept match
   */
  async acceptMatch(matchId) {
    return api.post(`/matching/${matchId}/accept`);
  },

  /**
   * Dismiss match
   */
  async dismissMatch(matchId, reason) {
    return api.post(`/matching/${matchId}/dismiss`, { reason });
  },

  // ==================== Match Statistics ====================
  
  /**
   * Get match statistics
   */
  async getMatchStatistics() {
    return api.get('/matching/statistics');
  },

  /**
   * Get match history
   */
  async getMatchHistory(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/matching/history?${queryString}`);
  },

  // ==================== Match Filters ====================
  
  /**
   * Apply match filters
   */
  async applyFilters(filters) {
    return api.post('/matching/filter', filters);
  },

  /**
   * Save match filters
   */
  async saveFilters(name, filters) {
    return api.post('/matching/filters/save', { name, filters });
  },

  /**
   * Get saved filters
   */
  async getSavedFilters() {
    return api.get('/matching/filters');
  },

  /**
   * Get advisor matches
   */
  async getAdvisorMatches(criteria) {
    return api.post('/matching/advisors', criteria);
  },

  /**
   * Get analyst matches
   */
  async getAnalystMatches(criteria) {
    return api.post('/matching/analysts', criteria);
  },

  /**
   * Get investor matches (for advisors)
   */
  async getInvestorMatches(criteria) {
    return api.post('/matching/investors', criteria);
  },
};

export default matchingService;
